const TableBlock = ({content = []}) => {
    if (!content.length) return null;

    return (
        <div className={`re-tableContainer`}>
            <table className={`re-table`}>
                <tbody className={`re-tbody`}>
                    {content.map((tr, tr_i) => {
                        return (
                            <tr key={tr_i} className={`re-tr`}>
                                {tr.map((td, td_i) => {
                                    return (
                                        <td key={td_i} className={`re-td`}>{td}</td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default TableBlock;
